import '~/js/modules/section-hero';

import 'slick-carousel';

const $sliderInclusions = $('.js-slick-slider-inclusions');
const $statusSliderInclusions = $('.js-slick-slider-counter');

$sliderInclusions.on('init reInit afterChange', (event, slick, currentSlide) => {
  const i = (currentSlide ? currentSlide : 0) + 1;

  $statusSliderInclusions.text(i + '/' + slick.slideCount);
});

$sliderInclusions.slick({
  centerMode: true,
  centerPadding: '0',
  cssEase: 'linear',
  pauseOnFocus: false,
  pauseOnHover: false,
  speed: 500,
  prevArrow: $('.js-prev-slide'),
  nextArrow: $('.js-next-slide')
});
